import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://hctsystem.web.id/api'
});
// baseURL: "http://api32.ptpas.org"
// baseURL: "https://api.ptpas.org"

export default instance;
